module.exports = __webpack_public_path__ + "img/rectangle2.d0d192a9.png";